var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.129,
    height: 16,
    viewBox: "0 0 13.129 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10320",
    "data-name": "Path 10320",
    d: "M161.915,41.994a.493.493,0,0,1,.362.149l5.407,5.407a.492.492,0,0,1,.149.362v7.944q.011,2.137-2.214,2.137h-8.7q-2.225,0-2.214-2.137V44.131q-.011-2.137,2.214-2.137Zm-3.942,10.882h2.563v2.571h1.022V52.876h2.571V51.854h-2.571V49.291h-1.022v2.563h-2.563Zm3.729-9.86h-.017v5.066h5.083Z",
    transform: "translate(-154.704 -41.994)",
    fill: "#03659a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.af41a9eec81a56f07192623ef5ad3ebc.svg";
export { ForwardRef as ReactComponent };